// Author liang gang qiang
// Date 2021-09-28 15:21:04

class MintalMesMstEquipment {
constructor({
        id = null,
        code = '',
        name = '',
        type = '',
        model = '',
        spec = '',
        desc = '',
        area = '',
        manu = '',
        status = '',
        active = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.type = type;
    this.model = model;
    this.spec = spec;
    this.desc = desc;
    this.area = area;
    this.manu = manu;
    this.status = status;
    this.active = active;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesMstEquipment();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'type',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.type',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'model',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.model',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spec',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.spec',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'desc',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.desc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'area',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.area',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'manu',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.manu',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'active',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.active',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstEquipment.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    codeFilter : "",
    nameFilter : "",
    typeFilter : "",
    modelFilter : "",
    specFilter : "",
    descFilter : "",
    areaFilter : "",
    manuFilter : "",
    statusFilter : "",
    activeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.type',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'modelFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.model',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.spec',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'descFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.desc',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'areaFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.area',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'manuFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.manu',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.status',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'activeFilter',
        label: 'label.mintal.mst.mintalMesMstEquipment.filter.active',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'type',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'model',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.model',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spec',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.spec',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'desc',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.desc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'area',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.area',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'manu',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.manu',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'status',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'active',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.active',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstEquipment.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesMstEquipment, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
